export { default as IconHasNoReviews } from './IconHasNoReviews'
